export function parseLooseDate(raw) {
  if (!raw) return null;
  if (raw instanceof Date && !Number.isNaN(raw.getTime())) return raw;
  const str = String(raw).trim();
  if (!str) return null;

  const isoParsed = new Date(str);
  if (!Number.isNaN(isoParsed.getTime())) return isoParsed;

  const slash = str.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/);
  if (!slash) return null;

  const day = Number(slash[1]);
  const month = Number(slash[2]);
  const year = Number(slash[3].length === 2 ? `20${slash[3]}` : slash[3]);
  const parsed = new Date(year, month - 1, day);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatLooseDate(raw, locale, options = {}) {
  const parsed = parseLooseDate(raw);
  if (!parsed) return '';
  return parsed.toLocaleDateString(locale, options);
}

export function extractMarginParts(marginRaw) {
  if (!marginRaw) return { dateChunk: '', timeChunk: '' };
  const parts = String(marginRaw).trim().split(/\s*\|\s*/).map((x) => x.trim()).filter(Boolean);
  if (parts.length >= 2) return { dateChunk: parts[0], timeChunk: parts[1] };
  if (parts.length === 1 && /^\d{1,2}:\d{2}\s*-\s*\d{1,2}:\d{2}$/.test(parts[0])) {
    return { dateChunk: '', timeChunk: parts[0] };
  }
  return { dateChunk: parts[0] || '', timeChunk: '' };
}

export function extractMarginDateChunk(marginRaw) {
  const { dateChunk } = extractMarginParts(marginRaw);
  if (!dateChunk || /^\d{1,2}:\d{2}/.test(dateChunk)) return '';
  if (dateChunk.includes(' - ')) return dateChunk.split(' - ')[0].trim();
  return dateChunk;
}
